<template>
  <div class="result-list" :class="{ 'result-list--grid': viewMode === 'grid' }">
    <article
      v-for="(item, index) in list"
      :key="item.id"
      class="result-card"
      :class="{ 'result-card--alt': index % 2 === 1 && viewMode === 'list' }"
      @click="goDetail(item)"
    >
      <div class="result-card__thumb">
        <img
          :src="item.image || defaultCover"
          :alt="item.title"
        />
      </div>

      <div class="result-card__body">
        <h3 class="result-card__title">{{ item.title }}</h3>
        <p class="result-card__abstract">{{ item.abstract }}</p>

        <div class="result-card__meta-grid">
          <div
            v-for="(column, columnIndex) in metaColumns(item)"
            :key="columnIndex"
            class="result-card__meta-col"
          >
            <p v-for="field in column" :key="field.id || field.label">
              <span>{{ field.label }}：</span>{{ field.value || '-' }}
            </p>
          </div>
        </div>
      </div>
    </article>

    <div v-if="!list.length" class="result-list__empty">
      暂无检索结果
    </div>
  </div>
</template>

<script>
import defaultCover from '@/assets/default-cover.png'
import { isArchiveResource } from '@/utils/resourceAccess'
import { mapGetters } from 'vuex'

export default {
  name: 'ResourcesResultList',
  props: {
    list: { type: Array, default: () => [] },
    viewMode: { type: String, default: 'list' }
  },
  data() {
    return { defaultCover }
  },
  computed: {
    ...mapGetters(['isLoggedIn'])
  },
  methods: {
    metaColumns(item) {
      const isGrid = this.viewMode === 'grid'
      const attributeLimit = isGrid ? 3 : 6
      const columnCount = isGrid ? 1 : 3
      const hiddenLabels = ['分类', '资源类型', '资源类别']
      const extraFields = (item.attributes || []).filter((field) => {
        const label = (field.label || '').trim()
        return label && !hiddenLabels.includes(label)
      })
      const fields = [
        { id: 'resource-type', label: '资源类别', value: item.resourceTypeLabel },
        ...extraFields.slice(0, attributeLimit)
      ]
      const columns = Array.from({ length: columnCount }, () => [])
      fields.forEach((field, index) => {
        columns[index % columnCount].push(field)
      })
      return columns
    },
    goDetail(item) {
      if (!item || !item.id) {
        return
      }
      if (isArchiveResource(item) && !this.isLoggedIn) {
        this.$emit('need-login')
        this.$message.warning('档案类资源需登录后访问')
        return
      }
      this.$router.push(`/resources/${item.id}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.result-list {
  display: flex;
  flex-direction: column;
  gap: $spacing-sm;
  margin-top: $spacing-base;

  &--grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
    gap: $spacing-base;

    .result-card {
      flex-direction: column;

      &__thumb {
        width: 100%;
        height: 200px;
      }

      &--alt {
        background: $color-white;
      }

      &__meta-grid {
        flex-direction: column;
        gap: $spacing-xs;
      }

      &__meta-col {
        min-width: 0;
      }
    }
  }

  &__empty {
    padding: $spacing-3xl;
    text-align: center;
    color: $color-text-light;
    background: $color-white;
    border-radius: 4px;
  }
}

.result-card {
  display: flex;
  gap: $spacing-base;
  padding: $spacing-base;
  background: $color-white;
  border-radius: 4px;
  box-shadow: 0 1px 8px rgba($color-brown-dark, 0.05);
  transition: box-shadow 0.2s;
  cursor: pointer;

  &:hover {
    box-shadow: 0 4px 16px rgba($color-brown-dark, 0.1);
  }

  &--alt {
    // background: rgba($color-cream, 0.6);
    background: #fff;
  }

  &__thumb {
    width: 120px;
    height: 150px;
    flex-shrink: 0;
    border-radius: 4px;
    overflow: hidden;
    background: $color-paper-light;
    box-shadow: 0 2px 8px rgba($color-brown-dark, 0.1);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-family: $font-serif;
    font-size: rem(18);
    font-weight: 700;
    color: $color-brown-dark;
    margin-bottom: $spacing-sm;
  }

  &__abstract {
    font-size: rem(13);
    line-height: 1.8;
    color: $color-text-light;
    margin-bottom: $spacing-base;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__meta-grid {
    display: flex;
    gap: $spacing-xl;
    flex-wrap: wrap;
  }

  &__meta-col {
    flex: 1;
    min-width: 140px;

    p {
      font-size: rem(12);
      line-height: 1.8;
      color: $color-text;

      span {
        color: $color-text-light;
      }
    }
  }
}

@media (max-width: 768px) {
  .result-card {
    flex-direction: column;

    &__thumb {
      width: 100%;
      height: 180px;
    }

    &__meta-grid {
      flex-direction: column;
      gap: $spacing-xs;
    }
  }
}
</style>
